"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _composeCallbackId = _interopRequireDefault(require("@htmniseko/htm-helpers/flywire/composeCallbackId"));
var _PaymentContext = _interopRequireDefault(require("../../../context/PaymentContext"));
var _Common = require("../../../components/Common");
var _BillingForm = _interopRequireDefault(require("../../../components/Form/BillingForm"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var FLYWIRE_LOCALES = {
  en: 'en-EN',
  ja: 'ja'
};
var SCRIPT_URL = 'https://checkout.flywire.com/flywire-payment.js';
var FlywirePaymentService = function FlywirePaymentService(_ref) {
  var env = _ref.env,
    recipientCode = _ref.recipientCode,
    tenantLabel = _ref.tenantLabel,
    onBack = _ref.onBack;
  var _useIntl = (0, _reactIntl.useIntl)(),
    locale = _useIntl.locale;
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    errors = _useState2[0],
    setErrors = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    loaded = _useState4[0],
    setLoaded = _useState4[1];
  var context = (0, _react.useContext)(_PaymentContext["default"]);
  var parsedReturnUrl = (0, _react.useMemo)(function () {
    var _context$endpoints, _context$paymentStore, _context$paymentStore2;
    if (!window || !window.location) return '';
    var returnUrl = context === null || context === void 0 || (_context$endpoints = context.endpoints) === null || _context$endpoints === void 0 || (_context$endpoints = _context$endpoints.flywireReentry) === null || _context$endpoints === void 0 ? void 0 : _context$endpoints.url;
    var baseUrl = returnUrl || window.location.href;
    var connector = baseUrl.includes('?') ? '&' : '?';
    var params = ['reentry=flywire', "folioId=".concat(context === null || context === void 0 || (_context$paymentStore = context.paymentStore) === null || _context$paymentStore === void 0 || (_context$paymentStore = _context$paymentStore.folio) === null || _context$paymentStore === void 0 ? void 0 : _context$paymentStore.id), "tenantLabel=".concat(tenantLabel), "sessionToken=".concat(context === null || context === void 0 || (_context$paymentStore2 = context.paymentStore) === null || _context$paymentStore2 === void 0 ? void 0 : _context$paymentStore2.sessionToken)];
    return "".concat(baseUrl).concat(connector).concat(params.join('&'));
  }, [context, tenantLabel]);
  var loadInitScript = function loadInitScript() {
    var documentScripts = (0, _toConsumableArray2["default"])(document.querySelectorAll('script'));
    var exist = documentScripts && documentScripts.find(function (script) {
      return script.src === SCRIPT_URL;
    });
    if (exist) setLoaded(true);else {
      var script = document.createElement('script');
      script.src = SCRIPT_URL, script.type = 'text/javascript', script.async = false, script.onload = function () {
        return setLoaded(true);
      }, document.getElementsByTagName('head')[0].appendChild(script);
    }
  };
  var loadFlywire = function loadFlywire(_ref2) {
    var amount = _ref2.amount,
      firstName = _ref2.firstName,
      lastName = _ref2.lastName,
      address = _ref2.address,
      city = _ref2.city,
      state = _ref2.state,
      country = _ref2.country,
      email = _ref2.email,
      phone = _ref2.phone;
    try {
      var _context$paymentStore3, _context$endpoints2, _context$paymentStore4;
      window.FlywirePayment.initiate({
        env: env,
        recipientCode: recipientCode,
        locale: FLYWIRE_LOCALES[locale || 'en'],
        recipientFields: {
          invoice_number: "".concat(context === null || context === void 0 || (_context$paymentStore3 = context.paymentStore) === null || _context$paymentStore3 === void 0 ? void 0 : _context$paymentStore3.folio.id)
        },
        callbackUrl: context === null || context === void 0 || (_context$endpoints2 = context.endpoints) === null || _context$endpoints2 === void 0 || (_context$endpoints2 = _context$endpoints2.flywireCallback) === null || _context$endpoints2 === void 0 ? void 0 : _context$endpoints2.url,
        callbackId: (0, _composeCallbackId["default"])(tenantLabel, context === null || context === void 0 || (_context$paymentStore4 = context.paymentStore) === null || _context$paymentStore4 === void 0 ? void 0 : _context$paymentStore4.folio.id),
        returnUrl: parsedReturnUrl,
        amount: amount,
        firstName: firstName,
        lastName: lastName,
        address: address,
        city: city,
        state: state,
        country: country,
        email: email,
        phone: phone,
        handleInvalidInput: function handleInvalidInput(errors) {
          return setErrors(errors);
        }
      });
    } catch (error) {}
  };
  (0, _react.useEffect)(function () {
    loadInitScript();
  }, []);
  var handleSubmit = function handleSubmit(values) {
    var firstName = values.firstName,
      lastName = values.lastName,
      email = values.email,
      phone = values.phone,
      address1 = values.address1,
      city = values.city,
      state = values.state,
      country = values.country,
      amount = values.amount;
    loadFlywire({
      firstName: firstName,
      lastName: lastName,
      email: email,
      phone: phone,
      address: address1,
      city: city,
      state: state,
      country: country,
      amount: amount
    });
  };
  return Array.isArray(errors) && errors.length > 0 && void 0, _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_Common.Header, {
    titleId: "htmPayment.flywire.service.subtitle",
    noteId: "htmPayment.flywire.service.note",
    warningId: "htmPayment.flywire.service.warning"
  }), !loaded && _react["default"].createElement(_Common.Loader, null), loaded && _react["default"].createElement(_BillingForm["default"], {
    displayAmount: true,
    hideJapan: true,
    provider: "flywire",
    onBack: onBack,
    onSubmit: handleSubmit
  }), _react["default"].createElement(_Common.Footer, {
    provider: "flywire"
  }));
};
var _default = exports["default"] = FlywirePaymentService;